import { requestWithToken } from '../utilities/request';
import * as _ from 'lodash';
const path = '/api/private/fields';
// interface FieldListProps {
//   company_id?: number;
//   name?: string;
//   address?: string;
//   use_buildee_flg?: number;
//   use_roan_flg?:number;
//   use_gk_flg ?:number;
//   order?:string;
// }

// private/fields/:field_id/field_images/list?limit=:limit¥&offset=:offset¥&columns=:columns¥&order=:order
const guideMap = fieldId => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`/${fieldId}/field_images/guidemap`),
    // params: params,
  });
};

const list = (fieldId, param) => {
  return requestWithToken({
    method: 'GET',
    params: param,
    url: path.concat(`/${fieldId}/field_images/list`),
  });
};

const imageList = fieldId => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`/${fieldId}/field_images/image_list`),
  });
};

const keyplan = (fieldId, param) => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`/${fieldId}/field_images/keyplan`),
    params: param,
  });
};

const upload = (fieldId, param, data) => {
  const form = new FormData();
  _.each(data, (value, column) => {
    form.append(column, value);
  });
  return requestWithToken({
    method: 'POST',
    url: path.concat(`/${fieldId}/field_images/upload_image`),
    processData: false,
    dataType: 'json',
    params: param,
    data: form,
    contentType: false,
  });
};

const update = (fieldId, id, data) => {
  const form = new FormData();
  _.each(data, (value, column) => {
    form.append(column, value);
  });
  return requestWithToken({
    method: 'PATCH',
    url: path.concat(`/${fieldId}/field_images/${id}`),
    processData: false,
    dataType: 'json',
    data: form,
    contentType: false,
  });
};

const updateOrder = (field_id, param) => {
  return requestWithToken({
    method: 'PATCH',
    url: path.concat(`/${field_id}/field_images/update_order`),
    data: param,
  });
};

const del = (fieldId, id) => {
  return requestWithToken({
    method: 'DELETE',
    url: path.concat(`/${fieldId}/field_images/${id}`),
    processData: false,
    dataType: 'json',
    contentType: false,
  });
};

/**
 * 現場画像情報取得
 * @param fieldId {int}
 * @param id {int}
 */
const show = (fieldId, id) => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`/${fieldId}/field_images/${id}`),
  });
};

export const FieldImageService = {
  guideMap,
  list,
  imageList,
  keyplan,
  upload,
  update,
  updateOrder,
  del,
  show,
};
export default FieldImageService;



// WEBPACK FOOTER //
// ./src/services/FieldImages.js